import lang from '@/lang'
import config from 'config'
import moment from 'moment'

const mandateUrls = {
  single: 'banking/directDebit/mandates',
  multiple: 'banking/directDebit/mandates',
}

const debitTransactionUrls = {
  multiple: 'banking/directDebit/transactions',
  single: 'banking/directDebit/transactions',
}

const resourceUrl = `${config.resourceHost}letter`

const DIRECT_DEBIT_TRANSACTION_STATE = {
  INITIATED: 'initiated',
  READY: 'ready',
  // 'notified',
  SUBMITTED: 'submitted',
  PROCESSING: 'processing',
  COLLECTED: 'collected',
  SETTLED: 'settled',
  REJECTED: 'rejected',
  RETURNED: 'returned',
  REFUNDED: 'refunded',
  CANCELLED: 'cancelled',
  // 'expired',
  CHECK: 'check',
  DUE: 'due',
  OVERDUE: 'overdue',
}

export default {
  DIRECT_DEBIT_TRANSACTION_STATE,
  resourceUrl,
  apiUrl: config.resourceHost,

  routes: {
    mandate: {
      details: `${config.resourceHost}${mandateUrls.single}`,
      list: `${config.resourceHost}${mandateUrls.multiple}`,
      listSetting: `${config.resourceHost}setting/userlist/mandate`,
    },
    debitTransaction: {
      details: `${config.resourceHost}${debitTransactionUrls.single}`,
      list: `${config.resourceHost}${debitTransactionUrls.multiple}`,
      listSetting: (listType: string) => `${config.resourceHost}setting/userlist/${listType}`,
    },
    invoice: {
      details: '/invoices',
    },
    customer: {
      details: '/customers',
    },
    statistics: {
      details: `${config.resourceHost}${debitTransactionUrls.single}/statistics`,
    },
  },

  filters: {
    'directDebitPlannedTransaction': [
      {
        name: 'all',
        title: lang.generics.allProperCase,
        quickFilter: {
          orderId: {
            filterType: 'nullValues',
            type: 'null',
          },
          state: {
            filterType: 'notSet',
            values: ['initiated'],
          },
        },
      },
      {
        name: 'ready',
        title: lang.debitTransactions.debitTransactionList.planned,
        quickFilter: {
          state: {
            type: 'set',
            values: ['ready'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'null',
          },
        },
      },
      {
        name: 'due',
        title: lang.debitTransactions.debitTransactionList.due,
        quickFilter: {
          state: {
            type: 'set',
            values: ['due'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'null',
          },
        },
      },
      {
        name: 'overdue',
        title: lang.debitTransactions.debitTransactionList.overdue,
        quickFilter: {
          state: {
            type: 'set',
            values: ['overdue'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'null',
          },
        },
      },
      {
        name: 'check',
        title: lang.debitTransactions.debitTransactionList.check,
        quickFilter: {
          state: {
            type: 'set',
            values: ['check'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'null',
          },
        },
      },
    ],
    'directDebitSettledTransaction': [
      {
        name: 'all',
        title: lang.generics.allProperCase,
        quickFilter: {
          orderId: {
            filterType: 'nullValues',
            type: 'notNull',
          },
        },
      },
      {
        name: 'submitted',
        title: lang.debitTransactions.debitTransactionList.submitted,
        quickFilter: {
          state: {
            type: 'set',
            values: ['submitted'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'notNull',
          },
        },
      },
      {
        name: 'settled',
        title: lang.debitTransactions.debitTransactionList.settled,
        quickFilter: {
          state: {
            type: 'set',
            values: ['settled'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'notNull',
          },
        },
      },
      {
        name: 'returned',
        title: lang.debitTransactions.debitTransactionList.returned,
        quickFilter: {
          state: {
            type: 'set',
            values: ['returned'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'notNull',
          },
        },
      },
      {
        name: 'success',
        title: lang.debitTransactions.debitTransactionList.success,
        quickFilter: {
          state: {
            type: 'set',
            values: ['settled'],
          },
          orderId: {
            filterType: 'nullValues',
            type: 'notNull',
          },
        },
      },
    ],
  },
}
